// extracted by css-extract-rspack-plugin
var _1 = "DxnTp37VXiZL-W2-zjOoTQ--";
export { _1 as "textareaWrapper" }
